import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagAiCheckIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2926 12.3094C22.2358 13.2526 22.2358 14.7838 21.2926 15.727L14.7147 22.3049C13.7716 23.248 12.2404 23.248 11.2972 22.3049L2.58797 13.5956C2.20824 13.2159 2 12.7014 2 12.1747V4.99663C2 3.8942 2.8942 3 3.99663 3H11.1625C11.7014 3 12.2036 3.20824 12.5834 3.58797L16.4954 7.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.50002 9.00249C7.77739 9.00249 8.00224 8.77764 8.00224 8.50027C8.00224 8.2229 7.77739 7.99805 7.50002 7.99805C7.22265 7.99805 6.9978 8.2229 6.9978 8.50027C6.9978 8.77764 7.22265 9.00249 7.50002 9.00249Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0908 10.5387L14.1807 14.7387L21.9973 5.99972",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTagAiCheckIcon;
